import { render, staticRenderFns } from "./MdElementValueList.vue?vue&type=template&id=0264b014&"
import script from "./MdElementValueList.vue?vue&type=script&lang=js&"
export * from "./MdElementValueList.vue?vue&type=script&lang=js&"
import style0 from "./MdElementValueList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports